export default __webpack_public_path__ + "static/media/story.7d59bca1.svg";